
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">項目概覽</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            石垣市開發計畫是一個革命性的綜合開發項目，致力於創造一個具投資價值、可持續發展的生活圈。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://static.readdy.ai/image/fd39da49b5eb347f174b313536d60b19/7c65deeadbf79ead96c51774f4bbb112.jpeg"
              alt="石垣市真榮里宮鳥開發計畫圖"
              className="w-full h-auto rounded-lg shadow-lg object-cover"
            />
            <p className="text-sm text-gray-500 text-center mt-2">
              ※ 建築外觀為風格示意圖，依設計規劃討論後優化調整
            </p>
          </div>
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">創新設計理念</h3>
            <p className="text-lg text-gray-600 leading-relaxed">
              我們的開發計畫結合了現代建築設計與沖繩當地的自然環境特色，創造出一個既具有現代感又保持傳統文化特色的社區空間。
            </p>
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900">可持續發展</h4>
                  <p className="text-gray-600">採用環保建材和綠色能源技術，結合台灣及日本優良建築材料共同打造石垣島指標性現代綠建築</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900">社區整合</h4>
                  <p className="text-gray-600">完善的住宅、商業和休閒設施配套</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900">文化保護</h4>
                  <p className="text-gray-600">尊重並保護當地傳統文化與自然環境</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-4-line text-teal-600 text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">住宅區域</h3>
            <p className="text-gray-600">現代化住宅設計，提供舒適的居住環境</p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-store-2-line text-teal-600 text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">商業設施</h3>
            <p className="text-gray-600">完善的商業配套，滿足日常生活需求</p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-tree-line text-teal-600 text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">綠色空間</h3>
            <p className="text-gray-600">豐富的綠化景觀和休閒娛樂設施</p>
          </div>
        </div>
      </div>
    </section>
  );
}
